<template>
  <div style="text-align: center;">
    <el-pagination :total="total" hide-on-single-page background @current-change="handleCurrentChange" :page-size="pageSize" :page-number="pageNumber" class="pagination" layout="prev, pager, next">
    </el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    total: Number,
    pageNumber: Number,
    pageSize: Number
  },
  data () {
    return {

    }
  },
  methods: {
    handleCurrentChange (val) {
      console.log(val);
      this.$emit('currentChange', val)
    }
  }
}
</script>
<style lang="less" scoped>
.pagination {
  & /deep/ .el-pager li:not(.disabled):hover {
    color: #fc5e5e;
  }
  & /deep/ .el-pager li:not(.disabled).active {
    background-color: #fc5e5e;
    color: #fff;
  }

  & /deep/ .el-pager li {
    font-size: 14px;
    font-weight: normal;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 50%;
    background-color: #fff;
    color: #909399;
  }
  & /deep/ .btn-prev,
  & /deep/ .btn-next {
    width: 40px;
    height: 40px;
    line-height: 40px;
    color: #909399;
    background-color: #fff;
    border-radius: 50%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/onlineSchool/diyTemplate/pagination.vue